/**
* share-clipboard-modal.js
*
* This is the share modal used for all clipping related sharing -
* 1. - Clipboard sharing, 2. - Clip sharing.
*/
(function(slideshare_object) {

  var SocialShareWindow = slideshare_object.utils.imports('SocialShareWindow'),
      socialShareUtil = slideshare_object.utils.imports('socialShareUtil'),

      shareType = {
        email: 'email',
        facebook: 'facebook',
        twitter: 'twitter',
        linkedin: 'linkedin',
      },

      EVENT_NAMESPACE = 'clipboard',

      /* Entity types that can be shared */
      CLIPBOARD = "clipboard",
      CLIP = "clip",

      /* Events */
      events = {
        clipShared: 'clip:shared',
        clipboardShared: 'clipboard:shared',
        beforeModalOpen: 'open.fndtn.reveal',
        afterModalOpen: 'opened.fndtn.reveal',
        afterModalClose: 'closed.fndtn.reveal'
      },

      defaults = {
        shareEntity : {},
        shareEntityType: CLIPBOARD,
        onClose: $.noop
      },

      /* Selectors */
      selectors = {
        modalTitle: '.j-modal-title',
        shareLinkInput: '.j-share-link-url',
        socialNetworkList: '.j-share-social-list',
        emailShareForm: '.j-share-email-form',
        shareEmailSend: '#share-email-send',
        shareEmailForm: '.j-share-email-form',
        shareEmailTo: '.j-share-email-to',
        shareEmailName: '.j-share-email-name',
        shareEmailMessage: '.j-share-email-msg',
        shareEmailClear: '.j-email-clear',
        shareEmailSent: '.j-email-sent',
        shareEmailFlash: '.j-email-flash'
      };

  /**
   * Constructor for ModalShare object used on clipboard page
   * @param {Object} config - Modal configuration object
   * @param {HTMLElement} config.el Parent modal element
   * @param {String} config.shareEntityType Type of entity to share (Clipboard/Clip)
   * @param {Object} config.shareEntity entity to share (Clipboard/Clip)
   * @param {Object} config.modalTitle Title for the modal
   */
  function ClipboardModalShare (config) {
    this.config = $.extend({}, defaults, config);
    this.shareEntity = this.config.shareEntity;
    this.shareEntityType = this.config.shareEntityType;
    this.onClose = this.config.onClose;
    this.shareTypes = [];
    this._init();
  }

  /**
   * Initializes dialog
   * @method
   * @private
   */
  ClipboardModalShare.prototype._init = function() {
    this.$el = $(this.config.el);
    this.$shareLinkInput = this.$el.find(selectors.shareLinkInput);
    this.$shareEmailSend = this.$el.find(selectors.shareEmailSend);
    this.$shareEmailForm = this.$el.find(selectors.shareEmailForm);
    this.$modalTitle = this.$el.find(selectors.modalTitle);

    if (!this.$el.length || $.isEmptyObject(this.shareEntity)) {
      throw new Error('Error initializing ShareModal');
    }

    if (!SocialShareWindow) {
      throw new Error('ClipboardModalShare dependency missing: SocialShareWindow');
    }

    //GA tracking for backwards compatibility with ModalShare
    this.gaTrackCategory = this.$el.data('ga-track-category');
    this.gaTrackAction = this.$el.data('ga-track-action');

    this._updateView();

    this._attachEventListeners();

  };

  /**
   * Makes updates to the view
   * @method _updateView
   * @private
   */
  ClipboardModalShare.prototype._updateView = function() {
    var modalTitle = this.config.modalTitle;
    if(modalTitle){
      this.$modalTitle.text(modalTitle);
    }
    this.$shareLinkInput.val(this.shareEntity.url);
    // Load username in email form if logged-in
    if (slideshare_object &&
        slideshare_object.utils.isUserAuthenticated()) {
      this.$el.find(selectors.shareEmailName).val(slideshare_object.user.login);
    }
  };

  /**
   * Adds event handlers required by dialog
   * @method _attachEventListeners
   * @private
   */
  ClipboardModalShare.prototype._attachEventListeners = function() {
    this.$el.on(events.afterModalClose, this._onClosed.bind(this));

    this.$el.on('click', selectors.socialNetworkList, this._onSocialNetworkClick.bind(this));
    this.$el.on('click', selectors.shareLinkInput, function(e) {
      $(e.target).select();
    });
    this.$el.on('submit', selectors.emailShareForm, this._onEmailShareSubmit.bind(this));
  };

  /**
   * Removes event handlers added by dialog
   * @method _detachEventListeners
   * @private
   */
  ClipboardModalShare.prototype._detachEventListeners = function() {
    this.$el.off();
  };

  /**
   * Handles sharing clipboard to various social networks
   */
  ClipboardModalShare.prototype._onSocialNetworkClick = function(e) {
    var $target = $(e.target),
      serviceType = $target.data('network'),
      clipDescription,
      defaultClipboardText = 'Make your own by #clipping the best @SlideShare slides.',
      defaultClipText = 'Share your own by #clipping the best @SlideShare slides.',
      socialShareParams,
      twitterShareText,
      popup;

    if (serviceType) {
      this.shareTypes.push(shareType[serviceType]);

      socialShareParams = {
        url: this.shareEntity.url,
        serviceType: serviceType
      };

      if (socialShareUtil.getNormalizedServiceName(serviceType) == socialShareUtil.SERVICE_TWITTER) {
        if (this.shareEntityType === CLIPBOARD) {
          twitterShareText = 'See ' + this.shareEntityType + ' "' + this.shareEntity.title + '". ' + defaultClipboardText;
        } else if (this.shareEntityType === CLIP) {
          // Ensure only first word from twitter share text is capitalized
          clipDescription = this.shareEntity.description.charAt(0).toLowerCase() + this.shareEntity.description.slice(1);
          twitterShareText = 'See ' + clipDescription + '. ' + defaultClipText;
        } else {
          twitterShareText = defaultClipboardText;
        }

        socialShareParams.description = twitterShareText;
      }

      popup = new SocialShareWindow(socialShareParams);
      popup.open();
    }
  };

  ClipboardModalShare.prototype._clearEmailErrorAlerts = function() {
    this.$el.find('.error').removeClass('error');
  };

  ClipboardModalShare.prototype._clearEmailFields = function() {
    this.$el.find(selectors.shareEmailClear).val('');
    this.$shareEmailSend.prop('disabled', false);
    this._clearEmailErrorAlerts();
  };

  /**
   * Handles sharing clipboard via email
   */
  ClipboardModalShare.prototype._onEmailShareSubmit = function(e) {
    e.preventDefault();
    var that = this,
        recipients = this.$el.find(selectors.shareEmailTo).val(),
        name = this.$el.find(selectors.shareEmailName).val(),
        message = this.$el.find(selectors.shareEmailMessage).val(),
        isSending = false;

    // Replace send with sending
    that.$shareEmailSend.val('Sending').addClass('sending').prop('disabled', true);
    that._clearEmailErrorAlerts();

    // Make sure email is not being sent
    if (!isSending) {
      isSending = true;

      $.ajax({
        url: '/w/clipboards/email_share',
        type: "POST",
        dataType: 'json',
        data: {
          id: this.shareEntity.id,
          name: name,
          recipients: recipients,
          message: message,
          entity: this.shareEntityType
        },
        success: function(data) {
          if (data.response_code === 0) {
            that.shareTypes.push(shareType.email);

            // Clear all current values
            that._clearEmailFields();

            // Hide email form
            that.$shareEmailForm.slideUp(400);

            // Display email sent div
            that.$el.find(selectors.shareEmailSent).slideDown(400);
            setTimeout(function() {
              that.$el.find(selectors.shareEmailSent).slideUp(400);
              that.$shareEmailForm.slideDown(400);
            }, 2000);
          } else {
            var $emailFlash = that.$el.find(selectors.shareEmailFlash);
            $emailFlash.text(data.response).show();
            switch (data.response_code) {
            case 1:
              // Error in 'to' field
              that.$el.find(selectors.shareEmailTo).addClass('error');
              break;
            case 2:
              // Error in 'from' field
              that.$el.find(selectors.shareEmailName).addClass('error');
              break;
            default:
              // Other error -- no field highlighting
              break;
            }
            setTimeout(function() {
              $emailFlash.fadeOut(400);
            }, 5000);
          }
        },
        complete: function() {
          isSending = false;
          that.$shareEmailSend.val('Send').removeClass('sending').prop('disabled', false);
        }
      });
    };
  };

  /**
   * Callback triggered after delete modal is closed
   * @method _onClosed
   * @private
   */
  ClipboardModalShare.prototype._onClosed = function() {
    this._detachEventListeners();
    this._trackEvents();
    this.onClose({
      shareEntity: this.shareEntity,
      shareEntityType: this.shareEntityType,
      shareTypes: this.shareTypes
    });
  };

  /**
   * Trigger share events after the modal is closed
   * @private
   */
  ClipboardModalShare.prototype._trackEvents = function() {
    var eventName, eventData;

    if (this.shareEntityType === CLIP) {
      eventName = events.clipShared;
      eventData = { clip: this.shareEntity };
    } else if (this.shareEntityType === CLIPBOARD) {
      eventName = events.clipboardShared;
      eventData = { clipboard: this.shareEntity };
    }

    if (eventName && eventData) {
      this.shareTypes.forEach(function (type) {
        $(document).trigger(eventName, $.extend(eventData,
          {shareType: type}));
      });
    }
  };

  /**
   * Close the modal.
   */
  ClipboardModalShare.prototype.close = function() {
    this.$el.foundation('reveal', 'close');
  };

  /**
   * Opens the modal.
   * @method open
   * @public
   */
  ClipboardModalShare.prototype.open = function() {
    this.$el.foundation('reveal', 'open');
    this.shareTypes = [];
  };

  slideshare_object.utils.exports('ClipboardModalShare', ClipboardModalShare);

})(window.slideshare_object);
